import { stableKey } from '@wix/gg-components';

export const apiKeys = {
  mutations: {
    createSite: () => stableKey(['api', 'createSite']),
    initStore: () => stableKey(['api', 'initStore']),
    setupProducts: () => stableKey(['api', 'setupProducts']),
    suggestStoreName: () => stableKey(['api', 'suggestStoreName']),
    setupStoreInitialization: () => stableKey(['api', 'setupStoreInitialization']),
    updateSiteSettings: () => stableKey(['api', 'updateSiteSettings']),
    publishSite: () => stableKey(['api', 'publishSite']),
    connectPaymentProvider: () => stableKey(['api', 'connectPaymentProvider']),
    launchStore: () => stableKey(['api', 'launchStore']),
  },
  queries: {
    getPaymentAggregators: () => stableKey(['api', 'getPaymentAggregators']),
    getSiteUrls: () => stableKey(['api', 'getSiteUrls']),
  },
} as const;
